import React, { Component, Fragment } from 'react';
import { observer, inject } from 'mobx-react';
import { withRouter } from "react-router";
import OrderModalNoUser from './OrderModalNoUser';
import { notification, Table, Select, Button, Input, InputNumber, Popconfirm, Tooltip  } from 'antd';

@inject(({ orderStore }) => ({ 
  cartList: orderStore.cartList,
  disCartList: orderStore.disCartList,
  merCartInfo: orderStore.merCartInfo,
  delCartInfo: orderStore.delCartInfo,

  modalOpenCart: orderStore.modalOpenCart,
  onModalCart: orderStore.onModalCart,

  valCondition: orderStore.valCondition,
  addTempOrder: orderStore.addTempOrder,
  disLastOrder: orderStore.disLastOrder,
  onChangValue: orderStore.onChangValue,
}))
@observer
class CartListNoUser extends Component {
  state = {
    cartList: [],

    editingKey: null,
    editData: {}
  };

  UNSAFE_componentWillMount() {
    if (this.props.ceType !== process.env.REACT_APP_TYPE_BRANCH) {
      this.props.disCartList();
    }
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    if (nextProps.cartList !== this.props.cartList) {
      this.setState({ cartList: nextProps.cartList});
    }

    if (nextProps.valCondition.selectCeCd !== this.props.valCondition.selectCeCd) {
      this.props.disCartList();
    }
  }

  handleOrder = () => {
    this.props.disCartList();   // a가 3개 중 한 개의 카트리스트를 삭제 => b가 새로고침 전 3개를 들고 주문하기 버튼 눌렀을 때에도 변함없이 3개 들고 가지 못하게 하기 위함
                                // 다시 한 번 조회함으로써, b는 db에 존재하지 않는 상품을 끌고가지 않음

    if (this.props.cartList.length <= 0) {
      notification.warning({placement: 'bottomLeft', message: `장바구니가 비어있습니다.`, duration: 2});
      return;
    } 
    this.props.disLastOrder();
    // console.log('카트리스트 : ', JSON.stringify(this.props.cartList))
    this.props.addTempOrder();
    this.setState({ editingKey: null, editData: {}});
    this.props.onModalCart(true);
  };



  handleChange = (type, name, item, record, index) => {
    const { editData } = this.state;
    const funcChange = (valuNm, value, option) => {
      if (type === 'Select') {
        this.setState({
          editData:{
            ...editData,
            [valuNm]:value,
            stCnt: option,
          }
        });
      } else {
        this.setState({
          editData:{
            ...editData,
            [valuNm]:value,
          }
        });
      }
    };
    
    if (type === 'Input') {
      return (
        <Input
          value={editData[name]}
          onChange={(e)=>funcChange(name, e.target.value)}
          style={{ width: '100%' }}
        />
      )
    } else if (type === 'InputNumber') {
      return (
        <Fragment>
          <InputNumber
            value={editData[name]}
            min={1}
            onChange={(value)=>funcChange(name, value)}
            style={{ width: '100%' }}
          />
        </Fragment>
      )
    }else if (type === 'Select') {
      return (
        <Fragment>
          <Select
            style={{ width: '100%' }}
            value={editData[name]}
            onChange={(value, option)=>funcChange(name, value, option.option.stCnt)}
          >
            {record.gdSizeList !== undefined && record.gdSizeList !== null &&
              record.gdSizeList.map(option=>{
              return(
                <Select.Option
                  disabled={option.stCnt === 0 ? true : false}
                  key={option.stSize}
                  option={option}
                >{option.stSize} 재고:{option.stCnt}</Select.Option>
              )
            })}
          </Select>
          {editData[name] === "기타" &&
          <Input
            placeholder={process.env.REACT_APP_ETCSIZE}
            value={editData.caEtc}
            onChange={(e)=>funcChange("caEtc", e.target.value)}
            style={{ width: '100%', marginTop: '5px' }}
          />
          }
        </Fragment>
      )
    }
  };

  save = async () => {
    const { editData } = this.state;
    console.log("editData : ", editData);

    if (parseInt(editData.stCnt) < parseInt(editData.caCnt)) {
      notification.warning({placement: 'bottomLeft', message: `구매가능 수량&재고(${parseInt(editData.stCnt)})을 초과하였습니다.`, duration: 2});
      return false;
    }
    

    if (editData.caGdSize === '기타' && editData.caEtc === '') {
      notification.warning({placement: 'bottomLeft', message: process.env.REACT_APP_ETCSIZE, duration: 2});
      return false;
    }

    this.props.merCartInfo(this.state.editData);
    this.setState({ editingKey: null, editData: {}});
  };

  render() {
    const { delCartInfo, modalOpenCart, onModalCart, valCondition, ceType } = this.props;
    const { cartList, editingKey } = this.state;
    const isEditing = record => record.RNUM === editingKey;
    const columns = [
      { title: 'No', dataIndex: 'RNUM', width: 70, align: 'center' },
      { title: '센터', dataIndex: 'caCeNm', width: 180, align: 'center' },
      // { title: '담당자', dataIndex: 'userNm', width: 150, align: 'center' },
      { title: '상품명', dataIndex: 'gdNm', width: 250, align: 'center' },
      { title: '사이즈', dataIndex: 'caGdSize', width: 150, align: 'center',
        render: (item, record, index) => { 
          const editable = isEditing(record);
          return editable ? (
            this.handleChange('Select', 'caGdSize', item, record, index)
          ) : (
            item === "기타"
            ? <Tooltip placement="topLeft" title={record.caEtc}>
                <span style={{color: 'blue'}}>{item}</span>
              </Tooltip>
            : item
          )
        },
        editable: true
      },
      { title: '주문수량', dataIndex: 'caCnt', width: 100, align: 'center',
        render: (item, record, index) => {
          const editable = isEditing(record);
          return editable ? (
            this.handleChange('InputNumber', 'caCnt', item, record, index)
            ) : (
            item
        )},
        editable: true
      },
      { title: '금액', dataIndex: 'gdPrice', width: 130, align: 'center',
        render: (item, record) => { return(
          <Fragment>
            {item !== undefined && item !== null && item !== '' &&
            (parseInt(item)*parseInt(record.caCnt)).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")}
          </Fragment>
        )}
      },
      // { title: '신청사유', dataIndex: 'reqReason', width: 130, align: 'center',
      //   render: (item, record, index) => { 
      //     const editable = isEditing(record);
      //     return editable ? (
      //       this.handleChange('Input', 'reqReason', item, record, index)
      //     ) : (
      //       item !== undefined && item !== null && item !== "" &&
      //       <Tooltip placement="topLeft" title={record.reqReason}>
      //         <span style={{color: 'blue'}}>신청사유</span>
      //       </Tooltip>
      //     )
      //   },
      //   editable: true
      // },
      { title: '수정/삭제', dataIndex: '', key: '', align: 'center', width: 220,
        render: (item, record, index) => {
          const editable = isEditing(record);
          return editable ? (
            <Fragment>
              <Button
                onClick={() => this.save()}
                style={{ marginRight: 8 }}
              >저장</Button>
              <Button
                onClick={() =>{
                  this.setState({editingKey: null});
                  this.setState({cartList: this.props.cartList})
                }}
              >취소</Button>
            </Fragment>
          ) : (
            <Fragment>
              <Button
                disabled={editingKey !== null}
                style={{ marginRight: 8 }}
                onClick={() => this.setState({
                  editingKey: record.RNUM,
                  editData: {
                    ...record,
                    caGdSizeOrg: record.caGdSize,
                    caCutOrg: record.caCnt
                  }
                })}
              >수정</Button>
              &nbsp;&nbsp;
              <Popconfirm 
                title="삭제하시겠습니까?"
                onConfirm={() => {
                  delCartInfo(record.caNo);
                }}
                onClick={(e)=>e.stopPropagation()}
              >
                <Button
                  disabled={editingKey !== null}
                >삭제</Button>
              </Popconfirm>
            </Fragment>
          );
        }
      },
    ];

    const totalMoney = () => {
      let total = 0;
      this.state.cartList.map(item=>{
        return(total = total + parseInt(item.gdPrice)*parseInt(item.caCnt))
      });
      return (
        <Fragment>{total.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")}</Fragment>
      );
    };
    return (
      (ceType === process.env.REACT_APP_TYPE_BRANCH && valCondition.selectCeCd === '') 
      ? <Fragment></Fragment>
      : 
      <Fragment>
        <div className="button-group">
          <h2>▶ 장바구니 {valCondition.exceptionYn === "Y" && <span style={{ color: 'blue' }}>(기준외주문)</span>}</h2>
          <h4 style={{ color: 'red' }}>
            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
            ※장바구니는 새벽 3시에 초기화됩니다.
          </h4>
          <div className="button-right">
            <ul>
              <li>
              <div className="cart_total" >
                ▶ 총액 : &nbsp;&nbsp;&nbsp;&nbsp;
                <span style={{ color: 'red' }}> 
                  {totalMoney()}
                </span>
                &nbsp;&nbsp;&nbsp; 원
                <Button
                  className="buttonR"
                  type="primary"
                  onClick={this.handleOrder}
                >주문하기</Button>
              </div>
              </li>
              <li>
                
              </li>
            </ul>
          </div>
        </div>

        <Table
          rowKey={(record)=>record.RNUM}
          dataSource={cartList}
          columns={columns}
          rowClassName="editable-row"
          pagination={false}
          scroll={{ x: 1420, y: 400 }}
        />

        <OrderModalNoUser
          ceType={ceType}
          modalOpen={modalOpenCart}
          modalClose={()=>onModalCart(false)}
          cartList={this.state.cartList}
        />
      </Fragment>
    );
  }

}

export default withRouter(CartListNoUser);
